import {Form, FormikProps} from "formik";
import React, {useEffect, useState} from "react";
import {ISelectOptionsItem} from "../../../contracts/select_options";
import {generateTransactionWalletTypeTitle, priceFormatWithUnitRial} from "../../../helpers/functions";
import useToastNotify from "../../../hook/useToastNotify";
import Input from "../../Elements/Form/Input";
import InputSelect from "../../Elements/Form/InputSelect";
import Button from "../../Elements/Button";
import {INewTransactionWalletData} from "../../../contracts/data/user";
import {TransactionWalletType} from "../../../constans/enumTypes";

const InnerNewTransactionWalletUserForm = (props: FormikProps<INewTransactionWalletData>) => {
    const {toastNotify} = useToastNotify()
    const [options, setOptions] = useState<Array<ISelectOptionsItem>>([
        {value: TransactionWalletType.WITHDRAW, label:generateTransactionWalletTypeTitle(TransactionWalletType.WITHDRAW)},
        {value: TransactionWalletType.DEPOSIT, label:generateTransactionWalletTypeTitle(TransactionWalletType.DEPOSIT)},
    ])

    useEffect(() => {
        if(props?.status?.hasOwnProperty('result')){
            toastNotify(props.status?.result?.status, props.status?.result?.message)
        }
    }, [props.status])

    return (
        <React.Fragment>
            <Form>
                <div className={"w-full"}>
                    <InputSelect name={'type'} label={'نوع تراکنش'}
                                 placeholder={'نوع تراکنش...'}
                                 handleSetValue={(values: any) => props.setFieldValue('type', values)}
                                 options={options} isMultiple={false} error={props?.errors?.type} // props?.errors?.type!
                                 meta={props.getFieldMeta('type')}
                                 defaultValue={options.find((item, _) => item.value === props?.values?.type)}
                    />
                    <Input name={"amount"} label={"مبلغ (ریال)"} placeholder={"10,000 ریال"} isRequired
                           meta={props.getFieldMeta('amount')} defaultValue={props.values?.amount} subContent={props?.values?.amount > 0 ? priceFormatWithUnitRial(props?.values?.amount) : ""}/>
                    <Input name={"description"} as={'textarea'} label={"توضیحات تراکنش"} placeholder={"توضیحات تراکنش.."}
                           meta={props.getFieldMeta('description')} defaultValue={props.values?.description}/>
                </div>
                <div className={"text-right"}>
                    <Button title={"ثبت تراکنش"} isLoading={props.isSubmitting}/>
                </div>
            </Form>
        </React.Fragment>
    )

}

export default InnerNewTransactionWalletUserForm